<template>
  <div>
    <app-overlay-loader v-if="preloader" />
    <div :class="{ 'loading-opacity': preloader }">
      <div class="row" v-if="inputs.reject_counter == 0">
        <div class="col-md-1"></div>
        <div class="col-md-10">
          <!-- <app-note
            class="mb-primary"
            :title="$t('Observaciones')"
            content-type="html"
            :notes="formInstruction1"
            v-if="inputs.is_complete == 0"
          /> -->
        </div>
      </div>
      <div class="row">
        <div class="col-6" style="text-align: left">
          <button class="btn btn-success" :disabled="disabledsupport" @click.prevent="download()">
            Generar archivo
          </button>
        </div>
        <br />
        <br />
      </div>

      <div class="row" v-if="showTable">
        <legend v-if="inputs.files">
          <p class="text-primary">Documentos anteriores</p>
        </legend>
        <table class="table table-sm table-striped" v-if="inputs.files">
          <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA CREACIÓN</th>
              <th scope="col">USUARIO</th>
              <th scope="col" class="text-center">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, key) in inputs.files" :key="key">
              <td class="align-middle">
                Registro de Ingreso de solicitud de acreditación y Acuse Recibo {{ key + 1 }}
              </td>
              <td class="align-middle">
                {{ item.created_at | dateFormat }}
              </td>
              <td class="align-middle">{{ technical }}</td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTb(item)"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- <div class="col-md-12" style="text-align: center">
          <h5 class="text-primary">¿La información presentada es correcta?</h5>
          <h6 v-if="inputs.reject_counter == 0">
            de no ser asi se solicitará la informacion de la OEC
          </h6>
          <h6 v-if="inputs.reject_counter > 0" class="text-danger">
            Recuerde que el OEC no tendrá mas oportunidades de realizar
            correcciones en caso de que la información no sea correcta
          </h6>
          <div
            class="row"
            style="text-align: center"
            v-if="inputs.is_complete == 0"
          >
            <div class="col-md-1"></div>
            <div class="col-md-10">
              <div class="form-group">
                <app-input
                  type="textarea"
                  v-model="inputs.technical_observation"
                />
              </div>
            </div>
          </div>

          <div
            class="row"
            style="text-align: center"
            v-if="inputs.is_complete == 1"
          >
            <div class="col-md-1"></div>
            <div class="col-md-10">
              <div class="form-group">
                <app-input type="textarea" v-model="inputs.observation104" />
              </div>
            </div>
          </div>

          <div class="form-group">
            <app-input
              type="radio-buttons"
              v-model="inputs.is_complete"
              :required="true"
              :list="list"
            />
          </div>
        </div> -->
        <!--<form
          ref="form"
          class="col-sm-6"
          data-url="/sendRequesttechnicalreview/update"
        >
          <legend>
            <p class="text-primary">Agregar nuevo archivo</p>
          </legend>
          <div>
            <div class="form-group">
              <label>Registro de Ingreso de solicitud de acreditación y Acuse Recibo:</label>
              <app-input
                type="file"
                :label="inputs.file ? inputs.file.name : $t('upload_your_file')"
                v-model="inputs.file"
                :required="true"
                v-if="!fileToShow"
              />
              <div class="mt-2">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTb(fileToShow)"
                  v-if="fileToShow"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>

                <button
                  type="submit"
                  class="btn btn-danger"
                  @click.prevent="
                    openDeleteModal('receipt_return_report_no_signed')
                  "
                  v-if="fileToShow"
                >
                  <app-icon name="trash-2" />
                  {{ $t("delete") }}
                </button>
              </div>
            </div>
            <button class="btn btn-primary" @click.prevent="submit">
              {{ $t("save") }}
            </button>
          </div>
        </form> -->
      </div>

      <div class="row">
        <div class="col-12 mt-3">
          <!-- <app-button
          :label="$t('Enviar solicitud')"
          class-name="btn-primary mr-2 mb-2 mb-sm-0"
          @submit="save"
        /> -->
        </div>
      </div>
      <app-confirmation-modal
        v-if="deleteModal"
        modal-id="delete"
        @confirmed="confirmed"
        @cancelled="cancelled"
        title="Confirmación"
        message="¿Desea eliminar este archivo?"
      />
    </div>
  </div>

  <!-- </form> -->
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../apiUrl";
export default {
  name: "SendRequest",

  mixins: [FormMixin],

  data() {
    return {
      preloader: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      showTable: false,
      inputs: {},
      bankList: [],
      technical: "",
      transactionTypeList: [],
      formInstruction1: [
        this.$t("Si existen observaciones escribelas en el siguiente recuadro"),
      ],
      rejectCounterInstruction: [
        this.$t(
          "Recuerde que el OEC no tendrá mas oportunidades de realizar correcciones en caso de que la información no sea correcta"
        ),
      ],
      formInstruction2: [this.$t("send_request_info2")],
      deleteModal: false,
      contador: 0,
      contadorArray: "",
      fileToShow: "",
      list: [
        {
          id: "0",
          value: "No",
        },
        {
          id: "1",
          value: "Si",
        },
      ],
      disabledsupport: false,
    };
  },

  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },

  watch: {
    "$store.state.accreditation.app": function () {
      this.loadForm();
    },
  },

  created() {
    this.loadForm();
    this.data();
    this.disabledsupport = localStorage.getItem("auth_id") === "true"; 
  },

  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    download() {
      let w;
      if (this.contador == null){
          this.contador= '';
      }
      w = window.open(
        `/common/pdf/generate?accAppId=${this.$store.state.accreditation.id}&contador=${this.contador}`, 
        "_blank"
      );
      w.focus();
    },

    submit() {
      // this.preloader = true;
      // var data = {};

      // data["accreditation_application_id"] = this.inputs.id;
      // data["is_complete"] = this.inputs.is_complete;
      // data["technical_observation"] = this.inputs.technical_observation;
      // data["observation104"] = this.inputs.observation104;
      // data["is_complete"] = this.inputs.is_complete;

      // let url = `${actions.SEND_REQUEST}/update`;
      // axios.post(url, data).then((response) => {
      //   this.preloader = false;
      //   this.afterSuccess(response);
      // });
      // if (!this.inputs.file) {
      //   this.$toastr.e(this.$t("Es necesario subir un archivo"));
      // } else {
      if (this.inputs.file) {
        let formData = new FormData();

        formData.append("file_" + this.contador, this.inputs.file);
        formData.append("accreditationId", this.inputs.id);
        formData.append("contador", this.contador);
        this.preloader = true;
        this.save(formData);
      } else {
        this.$toastr.e(this.$t("Se debe cargar el archivo"));
      }
      // }
    },

    loadForm() {
      if (this.$store.state.accreditation.app) {
        this.inputs = this.$store.state.accreditation.app;
      }
    },

    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },

    openTb(item) {
      const w = window.open(item.path, "_blank");
      w.focus();
    },

    afterSuccess(res) {
      this.$toastr.s(this.$t("updated_success"));
      this.data();
      // window.location = `${actions.ACCREDITATIONS_APPLICATIONS}`;
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    data() {
      this.$store.dispatch("getSendRequestOptions");

      this.preloader = true;

      this.axiosGet(
        `${actions.SEND_REQUEST}/show?accreditation_application_id=${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200) {
            if(response.data.receipt_return_report_no_signed.length > 0 ){
              if(this.inputs.counter_acusse_receipt != 1){
                this.showTable = true;
              }
            }
            this.inputs = response.data ? response.data : {};
            this.inputs.files = response.data.receipt_return_report_no_signed;
            this.technical = response.data.technical.full_name;
            this.contador = this.inputs.counter_acusse_receipt;
            this.contadorArray = this.contador - 1;
            // if(this.contadorArray + 1 == this.inputs.counter_acusse_receipt){
            this.fileToShow =
              response.data.receipt_return_report_no_signed[this.contadorArray];
            // }
          }
        })
        .catch((error) => {
          console.log("SendRequest: " + error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    confirmed() {
      this.deleteModal = false;
      this.inputs.file = null;
      this.inputs.attached_file = null;
      this.inputs.delete_file = 0;
    },

    openDeleteModal(fileName) {
      this.selected = fileName;
      this.deleteModal = true;
    },

    confirmed() {
      this.fileToShow = null;
    },

    cancelled() {
      this.deleteModal = false;
    },
  },
};
</script>